// ANRVA Info — cores da marca anrvainfo.com.br
// Navy profundo + laranja vibrante, moderno e confiável
module.exports = {
  effect: 'modern',
  colors: {
    main:            { light: '#f0f8ff', dark: '#04090f' },
    card:            { light: '#d8eef8', dark: '#080f1e' },
    surface:         { light: '#b8d8f0', dark: '#0d1a30' },
    action:          { light: '#e85d04', dark: '#f48c06' },
    actionHover:     { light: '#c84d00', dark: '#f9a825' },
    textPrimary:     { light: '#04090f', dark: '#f0f8ff' },
    textSecondary:   { light: '#0a1628', dark: '#c8e4f4' },
    textMuted:       { light: '#1a3a60', dark: '#90bcd8' },
    textMutedSubtle: { light: '#3a6090', dark: '#5a8ab0' },
    border:          { light: '#7ab0d0', dark: '#12253a' },
    borderSubtle:    { light: '#a8ccE4', dark: '#0a1628' },
    link:            { light: '#e85d04', dark: '#f48c06' },
    linkBg:          { light: '#fff4e6', dark: 'rgba(232,93,4,0.15)' },
    linkBorder:      { light: '#ffd8a8', dark: '#8a3a00' },
    linkHover:       { light: '#ffe8cc', dark: 'rgba(232,93,4,0.28)' },
    inputBg:         { light: '#ffffff', dark: '#080f1e' },
    inputBorder:     { light: '#7ab0d0', dark: '#12253a' },
    inputText:       { light: '#04090f', dark: '#f0f8ff' },
    focusRing:       { light: '#e85d04', dark: '#f48c06' },
    overlay:         { light: 'rgba(4,9,15,0.55)', dark: 'rgba(0,0,0,0.82)' },
    confirm:         { light: '#3a6090', dark: '#12253a' },
    confirmHover:    { light: '#1a3a60', dark: '#1c3450' },
    confirmText:     { light: '#ffffff', dark: '#f0f8ff' },
    confirmBg:       { light: '#f0f8ff', dark: '#080f1e' },
    confirmBorder:   { light: '#b8d8f0', dark: '#12253a' },
    success:         { light: '#065f46', dark: '#34d399' },
    successHover:    { light: '#022c22', dark: '#10b981' },
    successBg:       { light: '#ecfdf5', dark: 'rgba(6,78,59,0.3)' },
    successText:     { light: '#10b981', dark: '#6ee7b7' },
    successBorder:   { light: '#a7f3d0', dark: '#065f46' },
    error:           { light: '#c2410c', dark: '#f87171' },
    errorHover:      { light: '#9a3412', dark: '#ef4444' },
    errorBg:         { light: '#fff7ed', dark: 'rgba(127,29,29,0.3)' },
    errorText:       { light: '#ef4444', dark: '#fca5a5' },
    errorBorder:     { light: '#fed7aa', dark: '#7f1d1d' },
    info:            { light: '#0d1b2e', dark: '#38bdf8' },
    infoHover:       { light: '#0d1b2e', dark: '#0ea5e9' },
    infoBg:          { light: '#eff6ff', dark: 'rgba(13,27,46,0.4)' },
    infoText:        { light: '#0891b2', dark: '#7dd3fc' },
    infoBorder:      { light: '#bae6fd', dark: '#0d1b2e' },
  },
  borderRadius: {
    card:      '24px',
    container: '14px',
    page:      '20px',
    button:    '9999px',
    input:     '12px',
    badge:     '6px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '4px',
    device:  '6px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
